module.exports = __webpack_public_path__ + "img/like.cf42d964.svg";